import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import {
    Box,
    CssBaseline,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PeopleIcon from '@mui/icons-material/People';
import MenuIcon from '@mui/icons-material/Menu';

interface MenuProps {
    open: boolean;
    toggleDrawer: () => void;
}

const Menu: React.FC<MenuProps> = ({ open, toggleDrawer }) => {
    const handleLinkClick = (event: React.MouseEvent) => {
        event.stopPropagation();
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />

            {/* Top Navbar */}
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={toggleDrawer}
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        My App
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Sidebar Drawer */}
            <Drawer
                variant="permanent"
                open={open}
                sx={{
                    width: open ? 240 : 60,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {
                        width: open ? 240 : 60,
                        boxSizing: 'border-box',
                    },
                }}
            >
                <Toolbar />
                <List>
                    <ListItem component={Link} to="/dashboard" onClick={handleLinkClick}>
                        <ListItemIcon>
                            <DashboardIcon />
                        </ListItemIcon>
                        {open && <ListItemText primary="Dashboard" />}
                    </ListItem>
                    <ListItem component={Link} to="/profile" onClick={handleLinkClick}>
                        <ListItemIcon>
                            <AccountCircleIcon />
                        </ListItemIcon>
                        {open && <ListItemText primary="Profile" />}
                    </ListItem>
                    <ListItem component={Link} to="/users" onClick={handleLinkClick}>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        {open && <ListItemText primary="Users" />}
                    </ListItem>
                </List>
            </Drawer>

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    mt: 8,
                    width: `calc(100% - ${open ? 240 : 60}px)`,
                    transition: 'margin-left 0.3s',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default Menu;
